import commonUtils from '../../utils/commonUtils';
import ISearchOption, { ISearchOptGroup } from './SearchView/ISearchOption';

export const searchType = {
  product: 1,
  security: 2,
  organization: 3,
  expert: 4
};

const defaultAvatar = require('../../assets/images/default-avatar.png');
export const SEARCH_RESULT_COUNT = 10;
const NOSECURITYCODETEXT = '暂无代码';
const NODETAILTEXT = '暂无详情';

export function formatSearchOptions(
  response: any[], 
  type: number, 
  searchValue?: string, 
  allowCustom?: boolean,  // 自定义只存在不分组结构中
  alwaysCustom?: boolean, // 自定义常在，无论是否有搜索结果
  customVal?: any,
  mode?: string,
  ): ISearchOption[] | ISearchOptGroup[] {
  if (!response || !Array.isArray(response)) {
    return [];
  }

  let data;
  // 底层option内容格式处理
  function simpleOption(options: any) {
    const newOptions: ISearchOption[] | ISearchOptGroup[] = options.map(item => {
      const {id, name, title, avatar_url, company, description} = item;
      const newData = {
        value: id + '',
        text: name || title,
        avatar: avatar_url || defaultAvatar,
        desc: company || description,
        extra: item.extra
      };
      const {value, text, avatar, desc, extra} = newData;
      switch (type) {
        case searchType.security:
          if (mode === 'multiple') {
            const {note_id, code, short_name} = item;
            return {
              value: note_id + '',
              text: short_name + ' ' +  (code ? code : ''),
              extra: { short_name, code }
            };
          }
          return {
            text: desc + ' ' + text,
            value,
            desc:
              extra && extra.security_code
                ? `证券代码：${extra.security_code}`
                : NOSECURITYCODETEXT,
            extra
          };
        case searchType.expert:
          return {
            text,
            value,
            desc,
            avatar
          };
        default:
          return {
            text,
            value,
            desc
          };
      }
    });
    return newOptions;
  }
    
  // 存在多层级分组结构，需要增加一次遍历（证券+多选+label显示时）
  const hasChildren = commonUtils.hasValue(response[0], 'children');
  if (hasChildren && response.length >= 0) {
    data = response.map(item => { 
      const children = commonUtils.getValue(item, 'children');
      item.children = simpleOption(children);
      return item;
    });
  } else {
    // 单层不分组结构
    data = simpleOption(response);
    // 先判断是否允许自定义，在判断是否允许自定义常在(只有单层结构中才有自定义)
    if (allowCustom) {
      if (!data.length || alwaysCustom) {
        if (type === searchType.security) {
          data.unshift({
            text: searchValue || '',
            value: customVal !== undefined ? customVal : 0,
            desc: NOSECURITYCODETEXT,
            extra: {
              rating: '',
              remaining_maturity: '',
              security_code: '',
              security_type: ''
            }
          });
        } else {
          data.unshift({
            text: searchValue || '',
            value: customVal !== undefined ? customVal : 0,
            desc: NODETAILTEXT
          });
        }
      }
    }
  }
  return data;
}

// 搜索默认参数相关设置
export function defaultSearchField(type?: number, title?: string | null, placeholder?: string, noRenderTitle?: boolean) {
  const newType = type || searchType.product;
  switch (newType) {
    case searchType.product:
      return {
        title: noRenderTitle ? undefined : (title ? title : '产品名称'),
        placeholder: placeholder || '输入名称、拼音，搜索产品'
      };
    case searchType.organization:
      return {
        title: noRenderTitle ? undefined : (title ? title : '机构名称'),
        placeholder: placeholder || '输入机构名称、拼音…'
      };
    case searchType.security:
      return {
        title: noRenderTitle ? undefined : (title ? title : '证券名称'),
        placeholder: placeholder || '请输入代码/简称'
      };
    case searchType.expert:
      return {
        title: noRenderTitle ? undefined : (title ? title : '专家姓名'),
        placeholder: placeholder || '输入名称、拼音，搜索用户'
      };
    default:
      return {};
  }
}

// 将ISearchOption类型转成ILabeledValue类型
export function setLabelInValue(datas: ISearchOption | ISearchOption[], isForm?: boolean) {
  if (!datas || isForm) {
    return datas;
  }
  let newValue: any;
  if (!Array.isArray(datas)) {
    const {value, text} = datas;
    newValue = {
      key: String(value),
      label: text
    };
  } else {
    newValue = [];
    datas.map(item => {
      const {value, text} = item;
      const obj = {
        key: String(value),
        label: text
      };
      newValue.push(obj);
    });
  }
  return newValue;
}

// 
// export function setObjArray(stringList: any, objList: any[]) {
//   if (!stringList || !Array.isArray(stringList)) {
//     return [];
//   }

//   const list: any[] = [];
//   objList.map((item, index) => {
//     const {key} = item;
//     const obj: ISearchOption = {
//       value: stringList[index],
//       text: key,
//     };
//     list.push(obj);
//   });
//   return list;
// }

// 获取指定key的string数组或值
export function setStringValue(datas: any[], key: string) {
  if (!datas) {
    return datas;
  }
  let newValue: any;
  if (!Array.isArray(datas)) {
    newValue = datas[key];
  } else {
    newValue = [];
    datas.map(item => {
      newValue.push(item[key]);
    });
  }
  return newValue;
}

// export function setStringValue(datas: any[], value: string, type: string) {
//   if (!Array.isArray(datas) || !datas.length) {
//     return '';
//   }
//   for (const option of datas) {
//     const { value: sValue } = option;
//     if (value === sValue) {
//       return option[type] || '';
//     }
//   }
//   return '';
// }


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSearch/utils.ts